<template>
  <div class="indexbox">
    <wallet-head show_type="4" />

    <div class="container_box">
      <div-height height="3vw"></div-height>
      <!-- 标题 -->
      <div class="title_text">{{ $t('邀请好友') }}</div>

      <div-height height="22vw"></div-height>

      <!-- 二维码区域 -->
      <div class="qrcode_wrapper">
        <div class="qrcode_bg">
          <div ref="qrCodebox" class="qrcode"></div>
        </div>
      </div>

      <!-- 推广链接 -->
      <div class="link_box">
        <!-- <p class="label">{{ $t('推广链接') }}</p> -->
        <div class="url_display">
          {{ $t('推广链接') }}：{{ url }}
        </div>
      </div>

      <div-height height="5vw"></div-height>

      <!-- 复制按钮 -->
      <div class="copy_btn" @click="copyData(url)">
        {{ $t('复制链接') }}
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$get({
        url: "/api/v1/member/getInviteUrl",
        success: (res) => {
          this.url = res.data.url;
          this.$nextTick(() => {
            this.creatQrCode();
          });
        },
        tip: () => { },
      });
    },
    creatQrCode() {
      // 清空旧内容（防止重复生成）
      this.$refs.qrCodebox.innerHTML = '';
      new QRCode(this.$refs.qrCodebox, {
        text: this.url,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L,
      });
    },
    copyData(text) {
      this.$copyText(text).then(() => {
        this.$toast(this.$t('复制成功'));
      }).catch(() => {
        this.$toast(this.$t('复制失败'));
      });
    }
  },
};
</script>

<style lang="less" scoped>
.indexbox {
  width: 100%;
  min-height: 100vh;
  background: url("../../assets/img/share_bg3.png") no-repeat;
  background-size: 100% 100%;
  background-position: bottom;
  padding-top: 30px;
  /* 避免被 wallet-head 遮挡 */
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // box-sizing: border-box;
}

.container_box {
  margin: 0 auto;
  width: 90vw;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.title_text {
  font-size: 12vw;
  font-weight: 600;
  color: #fff;
  // margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  /* 🔥 关键：文字描边 */
  -webkit-text-stroke: 1.2px rgba(0, 0, 0, 0.3);
  /* 主描边 */
  text-shadow: none;
  /* 描边已足够，可关掉阴影避免冲突 */

  // font-size: 32px;
  // font-weight: 800;
  // background: linear-gradient(135deg, #FFD791, #F4BB67, #FF9E6D);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
  // background-clip: text;
  // margin-bottom: 36px;
  // text-align: center;
  // letter-spacing: 1.5px;
  // text-shadow: 0 2px 8px rgba(244, 187, 103, 0.3);
  // line-height: 1.1;

}

/* 二维码区域 */
.qrcode_wrapper {
  margin-bottom: 30px;
}

.qrcode_bg {
  width: 160px;
  height: 160px;
  background: #fff;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrcode {
  width: 140px;
  height: 140px;

  /deep/ img,
  /deep/ canvas {
    width: 100% !important;
    height: 100% !important;
    image-rendering: pixelated;
    /* 让二维码边缘更锐利 */
  }
}

/* 链接展示 */
.link_box {
  width: 100%;
  margin-bottom: 24px;
}

.label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
  text-align: left;
}

.url_display {
  width: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  color: #fff;
  word-break: break-all;
  line-height: 1.4;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* 复制按钮 */
.copy_btn {
  width: 80%;
  max-width: 300px;
  height: 48px;
  line-height: 48px;
  background: linear-gradient(270deg, #1989fa 0%, #00d8ff 100%);

  border-radius: 24px;
  color: #fff;
  // font-weight: 600;
  font-size: 16px;
  text-align: center;

  transition: transform 0.2s, box-shadow 0.2s;

}
</style>